<template>
  <div class="gratuity-modal-content">
    <div class="gratuity-modal-close" @click="closeAndNotify">
      <ion-icon name="close"></ion-icon>
    </div>
    <h2 class="gratuity-modal-title">{{ name }}</h2>
    <div class="gratuity-modal-body" v-html="template"></div>
  </div>
</template>

<style scoped>
.gratuity-modal-content {
  background: white;
  padding: 20px;
  height: 100%;
  position: relative;
}

.gratuity-modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  font-size: 24px;
  color: #333;
}

.gratuity-modal-title {
  text-align: center;
  color: var(--ion-color-primary);
  margin-top: 10px;
  margin-bottom: 20px;
  font-weight: bold;
}

.gratuity-modal-body {
  text-align: center;
}
</style>

<script>
import { modalController } from "@ionic/vue";

export default {
  name: "GratuityNotificationModal",
  props: {
    id: { type: Number, required: true },
    name: { type: String, required: true },
    template: { type: String, required: true }
  },
  methods: {
    closeAndNotify() {
      modalController.dismiss();
    }
  }
};
</script>
